export enum OmsInsuranceProvider {
  Easypost = "easypost",
  Shipsurance = "shipsurance",
  UpsCapital = "ups_capital",
}
